export default function($) {
    $('[data-fancybox="gallery"]').fancybox({
        hideScrollbar: false
    });
}
